<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="id">
            <template slot="processorTypeS" slot-scope="text">
                <span>{{ processorTypeS[text] }}</span>
            </template>
            <template slot="operation" slot-scope="text, record">
                <a-button type="link" @click="updateAuth(record,'03')" v-if="record.auditstate == '01' || record.auditstate == '02'">通过
                </a-button>
                    <a-button type="link" @click="updateAuth(record,'04')" v-if="record.auditstate == '01' || record.auditstate == '02'">驳回
                </a-button>
            </template>
            <template slot="shopcodedesc" slot-scope="text, record">
                <span v-if="record.shocode != ''">{{ record.shopcode + '/' + record.branchcode + '  ' + record.shopname + '/' + record.branchname }}</span>
                <span v-else></span>
            </template>
            <template slot="marketdesc" slot-scope="text, record">
                <span v-if="record.shocode != ''">{{ record.marketcode + '/' + record.marketname}}</span>
                <span v-else></span>
            </template>
            <template slot="companydesc" slot-scope="text, record">
                <span v-if="record.shocode != ''">{{ record.companycode + '/' + record.companyname}}</span>
                <span v-else></span>
            </template>

        </a-table>
        <a-pagination v-model="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize"
            @change="handlePageChange" show-less-items style="float: right; margin-top: 20px" />

    </div>
</template>
<script>

// apinum: "0"
// appenv: "pet"
// appkey: "APPKEY20211026174104WMJSNS2417"
// applanguage: "JAVA"
// appsecret: "SECRET20211026174104N381VUSO90"
// auditstate: "01"
// branchcode: ""
// branchname: ""
// bussinesskey: "18651662691"
// callbackurl: "localhost:8080"
// companycode: ""
// companyname: ""
// createtime: "2021-10-26 17:41:03"
// createuser: ""
// expires: "2021-10-26 09:35:18"
// id: "91"
// marketcode: ""
// marketname: ""
// name: "AppTest1"
// processor: "IFMSCALLBACK"
// remark: "123"
// shopcode: ""
// shopname: ""
// status: "0"
// topics: "ORDER_CALLBACK"
// uid: "12fc6baee0234bdebd2f44d87c7b582d"
// updatetime: "2022-04-26 16:21:10"
// updatetuser: ""
// username: "zhufeng"
const processorTypeS = {
    V3MT: "中仑零售应用",
    YXLMT: "银响力应用",
    IFMSCALLBACK: "智慧农贸数据回调应用",
    SQ: "银响力商圈应用",
};
const columns = [
    {
        title: "申请人",
        width: 200,
        dataIndex: "username",
        align: "center",
        ellipsises: true,
    },
    {
        title: "剩余调用次数",
        width: 120,
        dataIndex: "apinum",
        align: "center",
        ellipsises: true,
    },
    
    {
        title: "申请时间",
        width:180,
        dataIndex: "createtime",
        align: "center",
    },
    {
        title: "审核状态",
        width: 100,
        dataIndex: "auditstate",
        customRender: (text) => {
            if (text == "01") {
                return "未审核";
            } else if (text == "02") {
                return "审核中";
            } else if (text == "03") {
                return "审核成功";
            } else if (text == "04") {
                return "审核失败";
            }
        },
        align: "center",
    },
    {
        title: "应用名",
        width: 200,
        dataIndex: "name",
        align: "center",
        ellipsises: true,
    },
    {
        title: "应用类型",
        width: 200,
        dataIndex: "processor",
        scopedSlots: { customRender: "processorTypeS" },
        align: "center",
        ellipsises: true,
    },
    {
        title: "开发语言",
        width: 100,
        dataIndex: "applanguage",
        align: "center",
    },
    {
        title: "绑定门店",
        width: 300,
        scopedSlots: { customRender: "shopcodedesc" },
        ellipsis: true,
        align: "center",
    },
    {
        title: "绑定菜场",
        width: 300,
        scopedSlots: { customRender: "marketdesc" },
        ellipsis: true,

        align: "center",
    },
    {
        title: "公司信息",
        width: 300,
        scopedSlots: { customRender: "companydesc" },
        ellipsis: true,

        align: "center",
    },
    {
        title: "bussinesskey",
        width: 100,
        dataIndex: "bussinesskey",
        ellipsis: true,

        align: "center",
    },
    {
        title: "callbackurl",
        width: 150,
        dataIndex: "callbackurl",
        ellipsis: true,

        align: "center",
    },
    {
        title: "topics",
        width: 150,
        dataIndex: "topics",
        ellipsis: true,

        align: "center",
    },


    {
        title: "操作",
        dataIndex: "operation",
        align: "center",
        width: 120,
        scopedSlots: {
            customRender: "operation",
        },
        fixed:'right'
    },
];

export default {
    data() {
        return {
            processorTypeS,
            columns,
            tableData:[],
            tloading:false,
            clientWidth:800,
            searchP:{},
            pagination: {
                total: 0,
                pageSize: 10,
                page: 1,
            },
        };
    },
    methods: {
        handlePageChange(v) {
            this.pagination.page = v;
            this.getAppSumData();
        },
        getAppSumData(){
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: 'open/queryauth',
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.tableData = result.list;
                    that.pagination.total = parseInt(result.totalRecords);
                    that.pagination.pageSize = parseInt(result.pageSize);
                    that.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        },
        updateAuth(record,state){
            let that = this
            let params = {
                id:record.id,
                auditstate:state,
                urlparams:false
            };
            that.$store.dispatch({
                type: 'open/updateauth',
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    that.pagination.page = 1
                    that.getAppSumData()
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        }
    },

    components:{
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

